import { render } from "./Comp2.vue?vue&type=template&id=5b42b64d"
import script from "./Comp2.vue?vue&type=script&lang=js"
export * from "./Comp2.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__